import { useState } from "react";
import {
  CardDate,
  CardTitle,
  DetailsWrapper,
  Divider,
  FlowCardContainer,
  FlowViewButton,
  HeaderCard,
  InactiveInfo,
  OpenButton,
  PackageBadge,
} from "./styles";

import { IoMdOpen } from "react-icons/io";
import { HiOutlineDocumentDuplicate } from "react-icons/hi";
import { useIntl } from "react-intl";
import { FaRegTrashAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import api from "../../../service";
import { useToast } from "../../../hooks/toast";
import { Spin } from "antd";
import { useHistory } from "react-router";
import DeleteFlowModal from "./DeleteModalFlow";

const API_ERROR_CODES = {
  FLOW_HAS_EXECUTIONS: -48006,
};

const FlowCard = ({
  date,
  name,
  id,
  fetchFlows,
  availableForInactivation,
  active,
  documentPackage = false,
}) => {
  const intl = useIntl();
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();
  const history = useHistory();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const deleteUploadFlow = async (flowId) => {
    setLoading(true);
    try {
      await api.delete(`/upload-flow/${flowId}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });
      fetchFlows();
      addToast({
        type: "success",
        title: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({ id: "flow.deleted.success" }),
      });
    } catch (err) {
      const { code } = err.response
        ? typeof err.response === "string"
          ? JSON.parse(err.response.data)
          : err.response.data
        : {};

      switch (code) {
        case API_ERROR_CODES.FLOW_HAS_EXECUTIONS:
          addToast({
            type: "error",
            title: intl.formatMessage({ id: "error" }),
            description: intl.formatMessage({
              id: "flow.document.deleted.error.with_executions",
            }),
          });
          break;

        default:
          addToast({
            type: "error",
            title: intl.formatMessage({ id: "error" }),
            description: intl.formatMessage({
              id: `api.error.${err.response?.data?.description}`,
            }),
          });
          break;
      }
    } finally {
      setLoading(false);
    }
  };

  const handleOpenFlow = () =>
    history.push(`/admin/upload-documents/flow/${id}/edit`);

  return (
    <FlowCardContainer>
      <HeaderCard>
        <div>
          <CardTitle>{name}</CardTitle>

          <DetailsWrapper>
            <CardDate>
              {intl.formatMessage({ id: "created_at" })} {date}
            </CardDate>
            {documentPackage && (
              <PackageBadge
                data-test="flow-card-document-package-badge"
                title={intl.formatMessage({ id: "package" })}
              >
                <HiOutlineDocumentDuplicate size={12} />
                {intl.formatMessage({ id: "package" })}
              </PackageBadge>
            )}
          </DetailsWrapper>
        </div>
        {loading ? (
          <Spin size="small" />
        ) : active ? (
          <FaRegTrashAlt
            style={{ cursor: "pointer" }}
            size={20}
            color="rgba(220, 38, 38, 1)"
            onClick={() => setIsModalVisible(true)}
          />
        ) : (
          <InactiveInfo>
            {intl.formatMessage({ id: "flow.inactive" })}
          </InactiveInfo>
        )}
      </HeaderCard>

      <Divider />
      <FlowViewButton>
        <OpenButton onClick={handleOpenFlow}>
          <IoMdOpen size={16} />
          {intl.formatMessage({ id: "OPEN_FLOW" })}
        </OpenButton>
      </FlowViewButton>

      <DeleteFlowModal
        show={isModalVisible}
        intl={intl}
        name={name}
        deletingFlow={loading}
        handleClose={() => setIsModalVisible(false)}
        handleConfirm={() => deleteUploadFlow(id)}
        availableForInactivation={availableForInactivation}
      />
    </FlowCardContainer>
  );
};

export default FlowCard;
